import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-shared-loading',
    templateUrl: './shared.loading.component.html',
    styleUrls: ['./shared.loading.component.scss']
})
export class SharedLoadingComponent {
    @Input() hintText: string = '';
    @Input() dialogStyle: boolean = false;
    public color = 'warn';
    public mode = 'indeterminate';

}
